import { Navigate, useLocation, useParams } from 'react-router';

/** Sends a page under one version segment to the same page under another, e.g. /api/4.0.2/sdk -> /api/4.0-beta/sdk */
export function VersionRedirect({ to }: { to: string }) {
  const { '*': rest } = useParams();
  const { search, hash } = useLocation();

  return <Navigate to={{ pathname: `/api/${to}/${rest ?? ''}`, search, hash }} replace />;
}
